export const ptLang = {
  languageKey: 'pt',
  translates: {},
};
